import Vue from 'vue';
import Router from 'vue-router';

const Home = () => import('./views/Home.vue');
const AvailableTimes = () => import('./views/AvailableTimes.vue');
const Confirmation = () => import('./views/Confirmation.vue');

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: '/embedded/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/available-times',
      name: 'available-times',
      component: AvailableTimes,
    },
    {
      path: '/confirmation',
      name: 'confirmation',
      component: Confirmation,
    },
  ],
});
